export const isPreview = () => document.documentElement.hasAttribute("data-turbolinks-preview")
